import { useMemo } from "react";
import { object, bool, number } from "prop-types";
import { observer } from "mobx-react";
import { MinAvgMaxKeys } from "@repo/utils";
import { useEstimateStructure } from "@tools";
import { BufferTooltipContent } from "./components";

export const SummaryWorkTypeBufferTooltip = observer(({
  workType,
  cleanValue,
  isPrice,
  isMax,
}) => {
  const structure = useEstimateStructure();
  const { maxValuesAsBuffer } = structure.settings;
  
  const displayTwoValues = structure.displayWorkTypeTwoValues[workType.id];
  
  const valueKey = useMemo(() => {
    if(maxValuesAsBuffer)
      return MinAvgMaxKeys.AVG;
    if(isMax)
      return MinAvgMaxKeys.MAX;
    
    return displayTwoValues ? MinAvgMaxKeys.MIN : MinAvgMaxKeys.AVG;
  }, [isMax, displayTwoValues, maxValuesAsBuffer]);

  const bufferedValues = structure.getBufferValueForWorkType(workType.id, valueKey, isPrice);
  
  return <BufferTooltipContent
    isPrice={isPrice}
    cleanValue={cleanValue}
    bufferedValues={bufferedValues}
    splitBufferTypes
  />
});

SummaryWorkTypeBufferTooltip.propTypes = {
  workType: object.isRequired,
  cleanValue: number.isRequired,
  isMax: bool,
  isPrice: bool,
}